import { z } from 'zod';

export const tagDtoSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export const getTagDtoSchema = z.object({
  data: z.array(tagDtoSchema),
  limit: z.number(),
  skip: z.number(),
  total: z.number(),
});

export type TagDto = z.infer<typeof tagDtoSchema>;
